import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export default (props) => {
    return props.dependency === undefined ? _jsx(_Fragment, { children: _jsx("div", { className: "text-center m-2", children: _jsx("div", { className: "spinner-border text-primary", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) }) }) : props.children(props.dependency);
};
